// extracted by mini-css-extract-plugin
export default {"parent":"widgetSettings_parent__XDgsg","parentContent":"widgetSettings_parentContent__Zwfqs","parentContentItem":"widgetSettings_parentContentItem__oadYx"};